
import {getProList, getNewList, getNewDetail} from '../../services/api'
import utils from '../../utils/utils'

const dynamic = {
  state: {
    newPros: [],
    newsList: [],
    newDetail: {}
  },
  mutations: {
    setNewProList (state,data) {
      state.newPros = data;
    },
    setNewList (state,data) {
      state.newsList = data;
    },
    setNewDetail (state,data) {
      state.newDetail = data;
    }
  },
  actions: {
    ajaxNewPro ({ commit }) {
      var params = {
				pageIndex: 1,
				pageSize: 10,
				name: "",
				tip: ""
      }
      return new Promise((resolve, reject) => {
        getProList(params).then((response) => {
          commit('setNewProList', response.data);
          resolve(response.data);
        }).catch((error) => {
          reject(error);
        });
      })
    },
    ajaxNewList ({ commit },data) {
      var params = data;
      return new Promise((resolve, reject) => {
        getNewList(params).then((response) => {
          var result = response.data;
          if(result.status == 1){
            result.data.forEach(element => {
              var tempTime = new Date();
              tempTime.setTime(element.time);
              element.time = utils.timeFormat(tempTime, 'yyyy-MM-dd');
              return element;
            });
            commit('setNewList', result.data);
            resolve(result);
          }
        }).catch((error) => {
          reject(error);
        });
      })
    },
    ajaxNewDetail ({ commit }, data) {
      var params = data;
      return new Promise((resolve, reject) => {
        getNewDetail(params).then((response) => {
          var result = response.data;
          if(result.status == 1){
            commit('setNewDetail', result);
            resolve(result.data);
          }
        }).catch((error) => {
          reject(error);
        });
      })
    }
  },
  getters: {
    
  }
}

export default dynamic